/* eslint-disable max-len */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import _ from 'lodash';
import flow from 'lodash/fp/flow';
import map from 'lodash/fp/map';
import filter from 'lodash/fp/filter';
import uniqBy from 'lodash/fp/uniqBy';
import { isBlank } from 'underscore.string';
import { toJS } from 'mobx';
// eslint-disable-next-line import/no-extraneous-dependencies
import Big from 'big.js';
import { safeToBig } from 'shared/helpers/utils_math';
// eslint-disable-next-line import/no-cycle
import { taxes } from 'shared/order/taxes';
import { isRecOnly, isMedOnly } from 'shared/core/helpers/dispensaries';
import { adminFilteredProducts } from 'shared/graphql/product/queries';
import { getComplianceConfig } from 'shared/core/helpers/compliance';
import { DefaultImages, POTENCY_TYPES, POTENCY_UNITS, POTENCY_UNITS_DISPLAY, productEffects, StrainTypeOrder, MILLIGRAMS, GRAMS, MG_TO_G, MILLILITERS, WeightedSubcategories } from 'shared/constants';
import { replaceAWSSourceWithImgix } from 'shared/helpers/imgix';
import { GRAM_TO_OZ, GRAM_WEIGHT_REGEX, OZ_WEIGHT_REGEX, MG_WEIGHT_REGEX, CONC_WEIGHT_REGEX, PARTIAL_OZ_REGEX, MILLILITERS_PER_OZ, MULTIPLIER_REGEX, CategoryOptions, CategoriesForMenu, SubcategoryOptions, DefaultQuantityLimit } from 'shared/constants/products';
import { CannabinoidAbbrev } from 'shared/constants/cannabinoids';
import { parseNoidAbbreviation } from 'shared/utils/misc-utils';
/**
 * @param {Pick<import('types/graphql').GqlProducts, 'type' | 'Options'>} product
 * @returns {boolean}
 */ export var isWeightedProduct = function(param) {
    var type = param.type, _param_Options = param.Options, Options = _param_Options === void 0 ? [] : _param_Options;
    if (_.includes([
        'Flower',
        'Vaporizers',
        'Concentrate'
    ], type) && !_.includes(Options, 'N/A')) {
        return true;
    }
    if (type === 'Pre-Rolls' && Options.length && parseFloat(Options[0].replace(/\D/g, '')) && !_.includes(Options, 'N/A')) {
        return true;
    }
    return false;
};
export var isWeightedCategory = function(category) {
    return _.includes([
        'Flower',
        'Pre-Rolls',
        'Vaporizers',
        'Concentrates',
        'Concentrate'
    ], category);
};
// PF-8648 (work-cluster 3392c08a-1467-4710-a38f-d4332e0111cd): categories, other than the
// weighted cannabis ones above, that support grouping multiple named variants (e.g. apparel
// sizes) under one product. See PF-5727, PF-6522, PF-7852, PF-8033 for the source requests.
export var isSizeVariantCategory = function(category) {
    return _.includes([
        'Apparel'
    ], category);
};
/**
 * Whether a product should render as a single card with a multi-option selector (weight
 * options for cannabis categories, or size options for apparel) rather than a flat single price.
 * Additive over `isWeightedProduct` -- always true whenever `isWeightedProduct` is true, so
 * existing weighted-product behavior is unaffected.
 * @param {Pick<import('types/graphql').GqlProducts, 'type' | 'Options'>} product
 * @returns {boolean}
 */ export var hasSelectableOptions = function(product) {
    if (isWeightedProduct(product)) {
        return true;
    }
    var type = product.type, _product_Options = product.Options, Options = _product_Options === void 0 ? [] : _product_Options;
    return isSizeVariantCategory(type) && _.reject(Options, function(option) {
        return option === 'N/A';
    }).length > 1;
};
export var isWeightedSubcategory = function(subcategory) {
    return _.includes(WeightedSubcategories, subcategory);
};
export var isSubjectToExciseTax = function(param) {
    var type = param.type;
    return !_.includes([
        'Accessories'
    ], type);
};
export var getTaxInclusionNote = function(param) {
    var product = param.product, dispensary = param.dispensary, medical = param.medical, _param_printedMenu = param.printedMenu, printedMenu = _param_printedMenu === void 0 ? false : _param_printedMenu;
    var _computedTaxes_salesTaxExistence, _computedTaxes_cannabisTaxExistence;
    /**
   * We use the tax calculator to get values for a single-product cart.
   * Then work backwards to determine if taxes are included or added at checkout, without having to know
   * anything about how the computation works with a dispensary's tax config.
   */ var option = product.Options[0];
    var price = product.Prices[0];
    var computedTaxes = taxes({
        productKey: {
            quantity: 1,
            option: option,
            price: price,
            product: product
        }
    }, dispensary, medical);
    var details = _.get(computedTaxes, "details.0");
    var cannabisTaxFunc = details.cannabisTax, salesTaxFunc = details.salesTax, menuCannabisTax = details.menuCannabisTax, menuSalesTax = details.menuSalesTax;
    var hasCannabisCheckoutTax = cannabisTaxFunc(1) > 0;
    var hasSalesCheckoutTax = salesTaxFunc(1) > 0;
    var hasMenuCannabisTax = menuCannabisTax > 0;
    var hasMenuSalesTax = menuSalesTax > 0;
    var salesTaxExists = !_.isEmpty(computedTaxes === null || computedTaxes === void 0 ? void 0 : (_computedTaxes_salesTaxExistence = computedTaxes.salesTaxExistence) === null || _computedTaxes_salesTaxExistence === void 0 ? void 0 : _computedTaxes_salesTaxExistence[medical ? "med" : "rec"]);
    var cannabisTaxExists = !_.isEmpty(computedTaxes === null || computedTaxes === void 0 ? void 0 : (_computedTaxes_cannabisTaxExistence = computedTaxes.cannabisTaxExistence) === null || _computedTaxes_cannabisTaxExistence === void 0 ? void 0 : _computedTaxes_cannabisTaxExistence[medical ? "med" : "rec"]);
    var addedAtText = printedMenu ? "not included" : "will be added at checkout";
    var taxInclusionSentences = [];
    if (hasCannabisCheckoutTax && hasSalesCheckoutTax && !hasMenuCannabisTax && !hasMenuSalesTax) {
        taxInclusionSentences.push("Cannabis and Sales tax ".concat(addedAtText, "."));
    } else if (hasCannabisCheckoutTax && hasSalesCheckoutTax && hasMenuCannabisTax && hasMenuSalesTax) {
        taxInclusionSentences.push("All taxes included in price.");
    } else if (salesTaxExists && cannabisTaxExists && !hasCannabisCheckoutTax && !hasSalesCheckoutTax) {
        taxInclusionSentences.push("Cannabis and Sales tax not included.");
    } else {
        if (hasSalesCheckoutTax && !hasMenuSalesTax) {
            taxInclusionSentences.push("Sales tax ".concat(addedAtText, "."));
        } else if (hasSalesCheckoutTax) {
            taxInclusionSentences.push("Sales tax included.");
        } else if (salesTaxExists && !hasSalesCheckoutTax) {
            taxInclusionSentences.push("Sales tax not included.");
        }
        if (hasCannabisCheckoutTax && !hasMenuCannabisTax) {
            taxInclusionSentences.push("Cannabis tax ".concat(addedAtText, "."));
        } else if (hasCannabisCheckoutTax) {
            taxInclusionSentences.push("Cannabis tax included.");
        } else if (cannabisTaxExists && !hasCannabisCheckoutTax) {
            taxInclusionSentences.push("Cannabis tax not included.");
        }
    }
    var taxInclusionNote = taxInclusionSentences.length > 0 ? "*".concat(taxInclusionSentences.join(' ')) : '';
    return taxInclusionNote;
};
export var categoryPluralize = function(category) {
    return _.includes([
        'Edible',
        'Concentrate',
        'Tincture',
        'Oral'
    ], category) ? "".concat(category, "s") : category;
};
export var categorySingularize = function(category) {
    return(// eslint-disable-next-line lodash/prefer-lodash-method
    [
        "Edibles",
        "Concentrates",
        "Tinctures",
        "Topicals",
        "Clones",
        "Seeds",
        "Vaporizers",
        "Pre-Rolls"
    ].map(function(v) {
        return _.toLower(v);
    }).includes(_.toLower(category)) ? category.replace(/s([^s]*)$/, '') : category);
};
export var discountAmount = function(price, specialPrice) {
    if (specialPrice <= 0) {
        return 0;
    }
    return (parseFloat(1 - specialPrice / price) * 100.0).toFixed(0);
};
export var availablePricingTypes = function(dispensary) {
    if (isMedOnly(dispensary)) {
        return [
            "med"
        ];
    }
    if (isRecOnly(dispensary)) {
        return [
            "rec"
        ];
    }
    return [
        "rec",
        "med"
    ];
};
export var filterPricesBelowThreshold = function(product, prices) {
    var _product_Options = product.Options, Options = _product_Options === void 0 ? [] : _product_Options, _product_optionsBelowThreshold = product.optionsBelowThreshold, optionsBelowThreshold = _product_optionsBelowThreshold === void 0 ? [] : _product_optionsBelowThreshold;
    if (!(Options.length > 1)) {
        return prices;
    }
    if (!_.isEmpty(prices) && !_.isEmpty(optionsBelowThreshold)) {
        // find index of of each item in [options]
        // that does not match an item in [optionsBelowThreshold]
        var indices = _.map(Options, function(option, index) {
            return _.includes(optionsBelowThreshold, option) ? null : index;
        });
        var indicesToKeep = _.filter(indices, function(index) {
            return index !== null;
        });
        return _.map(indicesToKeep, function(index) {
            return prices[index];
        });
    }
    return prices;
};
export function isPotencyProduct(product) {
    return product.cbdContent || product.thcContent || !_.includes([
        'Accessories',
        'Apparel',
        'Clones'
    ], product.type);
}
export var getKeyFromTAC = function(cannabinoids, key, fallback) {
    return _.get(_.find(cannabinoids, function(noid) {
        var _noid_cannabinoid;
        return parseNoidAbbreviation(noid === null || noid === void 0 ? void 0 : (_noid_cannabinoid = noid.cannabinoid) === null || _noid_cannabinoid === void 0 ? void 0 : _noid_cannabinoid.name) === CannabinoidAbbrev.TAC;
    }), key, fallback);
};
export var getPotencyRanges = function(product) {
    var _product_THCContent, _product_CBDContent;
    if (!product) {
        return {};
    }
    var cannabinoids = _.get(product, 'cannabinoidsV2', []);
    var tacPotencyValue = getKeyFromTAC(cannabinoids, "value", 0);
    var tacPotencyRangeV2 = [
        tacPotencyValue,
        tacPotencyValue
    ];
    var thcPotencyRange;
    thcPotencyRange = _.isArray(product === null || product === void 0 ? void 0 : (_product_THCContent = product.THCContent) === null || _product_THCContent === void 0 ? void 0 : _product_THCContent.range) ? _to_consumable_array(product.THCContent.range) : [
        0
    ];
    var cbdPotencyRange;
    cbdPotencyRange = _.isArray(product === null || product === void 0 ? void 0 : (_product_CBDContent = product.CBDContent) === null || _product_CBDContent === void 0 ? void 0 : _product_CBDContent.range) ? _to_consumable_array(product.CBDContent.range) : [
        0
    ];
    // for each cannabinoid, if range does not have two values, give it two values
    if (cbdPotencyRange.length !== 2) {
        cbdPotencyRange = [
            0
        ].concat(_to_consumable_array(cbdPotencyRange));
    }
    if (thcPotencyRange.length !== 2) {
        thcPotencyRange = [
            0
        ].concat(_to_consumable_array(thcPotencyRange));
    }
    var _obj;
    return _obj = {}, _define_property(_obj, POTENCY_TYPES.CBD, cbdPotencyRange), _define_property(_obj, POTENCY_TYPES.THC, thcPotencyRange), _define_property(_obj, POTENCY_TYPES.TAC, tacPotencyRangeV2), _obj;
};
export var getPotencyValues = function(product) {
    if (!product) {
        return {};
    }
    var ranges = getPotencyRanges(product);
    var _obj;
    return _obj = {}, _define_property(_obj, POTENCY_TYPES.CBD, _.max(ranges[POTENCY_TYPES.CBD])), _define_property(_obj, POTENCY_TYPES.THC, _.max(ranges[POTENCY_TYPES.THC])), _define_property(_obj, POTENCY_TYPES.TAC, _.max(ranges[POTENCY_TYPES.TAC])), _obj;
};
// should return an object with the accurate CBD and THC potency values
// if either CBD or THC is a range, the corresponding value will be an array with those potency values
// if either CBD or THC is NOT a range, the corresponding value will be an array with a single potency value
export var getAccuratePotencyValues = function(product) {
    if (!product) {
        return {};
    }
    var CBDContent = product.CBDContent, THCContent = product.THCContent;
    var tacPotencyValue = getKeyFromTAC(product.cannabinoidsV2, 'value', 0);
    var safeTacValue = tacPotencyValue ? [
        tacPotencyValue
    ] : undefined;
    var _obj;
    return _obj = {}, _define_property(_obj, POTENCY_TYPES.CBD, CBDContent ? getAccuratePotency(CBDContent.range) : undefined), _define_property(_obj, POTENCY_TYPES.THC, THCContent ? getAccuratePotency(THCContent.range) : undefined), _define_property(_obj, POTENCY_TYPES.TAC, safeTacValue), _obj;
};
export var getAccuratePotency = function(potencyRange) {
    var isRange = isPotencyRange(potencyRange);
    if (isRange) {
        // get the lower and upper bound of the potency range
        var _potencyRange = _sliced_to_array(potencyRange, 2), lowerBound = _potencyRange[0], upperBound = _potencyRange[1];
        // if the range has two indexes but the first one is 0 or null or undefined, then only return the upperBound
        // because we only want to use a range if it is between two values > 0
        if (lowerBound === 0 || _.isNil(lowerBound)) {
            return [
                upperBound
            ];
        }
        // if the range has two indexes but the upperBound is null or undefined, and the lowerBound is valid, return it
        if (_.isNil(upperBound) && !_.isNil(lowerBound)) {
            return [
                lowerBound
            ];
        }
        return potencyRange;
    }
    // the only case where the potency is a range and the only value is 0
    // set to null so the value can be overridden if the item is connected to a library product
    if ((potencyRange === null || potencyRange === void 0 ? void 0 : potencyRange.length) === 1 && (potencyRange[0] === null || potencyRange[0] === 0 || potencyRange[0] === undefined)) {
        return null;
    }
    // if the potency range is an empty array return null
    if ((potencyRange === null || potencyRange === void 0 ? void 0 : potencyRange.length) === 0) {
        return null;
    }
    // the only cases where potency range would be defined but isRange would be false
    // is if both values in the range are equal or the range has one value. return the first value
    if (potencyRange && !!potencyRange[0]) {
        return [
            potencyRange[0]
        ];
    }
    return null;
};
export var isPotencyRange = function(range) {
    if (!_.isArray(range)) {
        return false;
    }
    if (range.length !== 2) {
        return false;
    }
    if (!_.isFinite(_.toNumber(range[0])) || !_.isFinite(_.toNumber(range[1]))) {
        return false;
    }
    return range[0] !== range[1];
};
export var regulateRangeValue = function(range) {
    if (!isPotencyRange(range) && range[0] !== range[1] || !_.isArray(range)) {
        return [
            0,
            0
        ];
    }
    range = _.map(range, Number);
    return range[0] > range[1] ? [
        range[0],
        range[0]
    ] : range;
};
export var getPotencyUnits = function(product) {
    if (!product) {
        return {};
    }
    var fallbackUnit = _.includes([
        "Edible",
        "Topicals",
        "Tincture",
        "CBD"
    ], product.type) ? POTENCY_UNITS.MILLIGRAMS : POTENCY_UNITS.PERCENTAGE;
    var __get;
    var cbdUnit = (__get = _.get(product, "CBDContent.unit", fallbackUnit)) !== null && __get !== void 0 ? __get : fallbackUnit;
    var __get1;
    var thcUnit = (__get1 = _.get(product, "THCContent.unit", fallbackUnit)) !== null && __get1 !== void 0 ? __get1 : fallbackUnit;
    var cannabinoids = _.get(product, 'cannabinoidsV2', []);
    var _getKeyFromTAC;
    var tacUnit = (_getKeyFromTAC = getKeyFromTAC(cannabinoids, 'unit', fallbackUnit)) !== null && _getKeyFromTAC !== void 0 ? _getKeyFromTAC : fallbackUnit;
    var _obj;
    return _obj = {}, _define_property(_obj, POTENCY_TYPES.CBD, cbdUnit || fallbackUnit), _define_property(_obj, POTENCY_TYPES.THC, thcUnit || fallbackUnit), _define_property(_obj, POTENCY_TYPES.TAC, tacUnit), _obj;
};
function fractionToDecimal(fraction) {
    // handles non fraction inputs also like integers
    var split = _.split(fraction, '/');
    var result = split[0];
    if (split.length > 1 && parseInt(split[1], 10) !== 0) {
        result = split[0] / split[1];
    }
    return result;
}
export var getWeightAndUnits = function(weightString) {
    if (isConcentrate(weightString)) {
        return {
            amount: parseFloat(parseGramWeight(weightString)),
            unit: 'gC'
        };
    }
    if (isGram(weightString)) {
        return {
            amount: parseFloat(parseGramWeight(weightString)),
            unit: 'g'
        };
    }
    if (isOz(weightString) || isPartialOz(weightString)) {
        var weight = parseOzWeightNoConversion(weightString);
        return {
            amount: parseFloat(fractionToDecimal(weight)),
            unit: 'oz'
        };
    }
    if (isMg(weightString)) {
        return {
            amount: parseFloat(parseMgWeightNoConversion(weightString)),
            unit: 'mg'
        };
    }
    // if our weight string is 'Any Weight'
    return null;
};
export var getPotency = function(product) {
    var _getPotencyRanges = getPotencyRanges(product), CBDRange = _getPotencyRanges.CBD, THCRange = _getPotencyRanges.THC, TACRange = _getPotencyRanges.TAC;
    var _getPotencyUnits = getPotencyUnits(product), CBDUnit = _getPotencyUnits.CBD, THCUnit = _getPotencyUnits.THC, TACUnit = _getPotencyUnits.TAC;
    var TACValue = _.max(TACRange) || ''; // TAC doesn't allow ranges
    var _obj;
    return _obj = {}, _define_property(_obj, POTENCY_TYPES.CBD, {
        unit: CBDUnit,
        range: CBDRange
    }), _define_property(_obj, POTENCY_TYPES.THC, {
        unit: THCUnit,
        range: THCRange
    }), _define_property(_obj, POTENCY_TYPES.TAC, {
        unit: TACUnit,
        value: TACValue
    }), _obj;
};
export function getPotencyString(potency, unit) {
    var space = function(u) {
        return u === POTENCY_UNITS.MILLIGRAMS ? ' ' : '';
    };
    return Number(potency) > 0 ? "".concat(potency).concat(space(unit)).concat(POTENCY_UNITS_DISPLAY[unit]) : '--';
}
export var getFormattedPotency = function(product) {
    if (!product) {
        return {};
    }
    var ranges = getPotencyRanges(product);
    var units = getPotencyUnits(product);
    var CBDString = getPotencyString(_.last(ranges.CBD), units.CBD);
    var THCString = getPotencyString(_.last(ranges.THC), units.THC);
    var TACString = getPotencyString(_.last(ranges[POTENCY_TYPES.TAC]), units[POTENCY_TYPES.TAC]);
    if (ranges.THC[0] > 0 && ranges.THC[0] !== ranges.THC[1]) {
        THCString = "".concat(getPotencyString(ranges.THC[0], units.THC), " - ").concat(THCString);
    }
    if (ranges.CBD[0] > 0 && ranges.CBD[0] !== ranges.CBD[1]) {
        CBDString = "".concat(getPotencyString(ranges.CBD[0], units.CBD), " - ").concat(CBDString);
    }
    var _obj;
    return _obj = {}, _define_property(_obj, POTENCY_TYPES.CBD, CBDString), _define_property(_obj, POTENCY_TYPES.THC, THCString), _define_property(_obj, POTENCY_TYPES.TAC, TACString), _obj;
};
export var checkForPotencyValue = function(potencyData) {
    return !isBlank(potencyData) && _.isFinite(_.toNumber(potencyData)) || isPotencyRange(potencyData);
};
// Raw availability for business-rule enforcement. Unlike getQuantityRemaining,
// this can return 0 for POS-backed products and should be used by server-side validation.
export var getRawQuantityRemaining = function(product, option) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_isKiosk = _ref.isKiosk, isKiosk = _ref_isKiosk === void 0 ? false : _ref_isKiosk, _ref_ignoreThreshold = _ref.ignoreThreshold, ignoreThreshold = _ref_ignoreThreshold === void 0 ? false : _ref_ignoreThreshold, _ref_defaultLimit = _ref.defaultLimit, defaultLimit = _ref_defaultLimit === void 0 ? 10 : _ref_defaultLimit;
    var _product_POSMetaData, _product_POSMetaData1;
    if (!product || !((_product_POSMetaData = product.POSMetaData) === null || _product_POSMetaData === void 0 ? void 0 : _product_POSMetaData.children) && !product.manualInventory) {
        return defaultLimit;
    }
    var quantityRemaining = defaultLimit;
    if (((_product_POSMetaData1 = product.POSMetaData) === null || _product_POSMetaData1 === void 0 ? void 0 : _product_POSMetaData1.children) && !product.manualInventory) {
        var _product_POSMetaData2 = product.POSMetaData, _product_POSMetaData_children = _product_POSMetaData2.children, children = _product_POSMetaData_children === void 0 ? [] : _product_POSMetaData_children;
        var POSOption = _.find(children, {
            option: option
        });
        // if none of the pos meta children match the selected option, return default limit.
        if (!POSOption) {
            return defaultLimit;
        }
        quantityRemaining = POSOption.quantity;
        var quantityAvailable = isKiosk ? POSOption.kioskQuantityAvailable : POSOption.quantityAvailable;
        if (!_.isNil(quantityAvailable) && !ignoreThreshold) {
            quantityRemaining = quantityAvailable;
        }
        quantityRemaining = parseInt(quantityRemaining, 10);
        return quantityRemaining < 0 ? 0 : quantityRemaining;
    }
    var inventoryOption = _.find(product.manualInventory, {
        option: option
    });
    if (inventoryOption) {
        quantityRemaining = inventoryOption.inventory;
    }
    return quantityRemaining < 0 ? 0 : quantityRemaining;
};
// UI-facing quantity helper. POS-backed products are floored at 1 so dropdowns
// can render cleanly; order validation should use getRawQuantityRemaining instead.
export var getQuantityRemaining = function(product, option) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref_isKiosk = _ref.isKiosk, isKiosk = _ref_isKiosk === void 0 ? false : _ref_isKiosk, _ref_ignoreThreshold = _ref.ignoreThreshold, ignoreThreshold = _ref_ignoreThreshold === void 0 ? false : _ref_ignoreThreshold, _ref_defaultLimit = _ref.defaultLimit, defaultLimit = _ref_defaultLimit === void 0 ? 10 : _ref_defaultLimit;
    var _product_POSMetaData;
    var quantityRemaining = getRawQuantityRemaining(product, option, {
        isKiosk: isKiosk,
        ignoreThreshold: ignoreThreshold,
        defaultLimit: defaultLimit
    });
    if ((product === null || product === void 0 ? void 0 : (_product_POSMetaData = product.POSMetaData) === null || _product_POSMetaData === void 0 ? void 0 : _product_POSMetaData.children) && !product.manualInventory) {
        return quantityRemaining < 1 ? 1 : quantityRemaining;
    }
    return quantityRemaining;
};
export function getRangeForQuantityDropdown(param) {
    var product = param.product, option = param.option, quantityInCart = param.quantityInCart, isKiosk = param.isKiosk, _param_defaultLimit = param.defaultLimit, defaultLimit = _param_defaultLimit === void 0 ? 10 : _param_defaultLimit;
    var quantityRemaining = getQuantityRemaining(product, option, {
        isKiosk: isKiosk,
        defaultLimit: defaultLimit
    });
    var maxQuantityForSelection = _.clamp(quantityRemaining, 1, quantityInCart > defaultLimit ? quantityInCart : defaultLimit);
    return _.range(1, maxQuantityForSelection + 1);
}
// Single source of truth for the checkout quantity ceiling, shared with callers (e.g. the
// order validator's guard-rejection reason classification) that need to know the ceiling
// itself, not just the already-clamped result — keeps them from re-deriving the same
// formula and silently drifting out of sync with it.
export function getCheckoutLimit(dispensary) {
    var _dispensary_storeSettings, _dispensary_storeSettings1;
    if (dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_storeSettings = dispensary.storeSettings) === null || _dispensary_storeSettings === void 0 ? void 0 : _dispensary_storeSettings.quantityLimitMaxAvailable) {
        return Infinity;
    }
    var _dispensary_storeSettings_quantityLimit;
    return (_dispensary_storeSettings_quantityLimit = dispensary === null || dispensary === void 0 ? void 0 : (_dispensary_storeSettings1 = dispensary.storeSettings) === null || _dispensary_storeSettings1 === void 0 ? void 0 : _dispensary_storeSettings1.quantityLimit) !== null && _dispensary_storeSettings_quantityLimit !== void 0 ? _dispensary_storeSettings_quantityLimit : DefaultQuantityLimit;
}
export function getMaxQuantityForCheckout(param) {
    var product = param.product, option = param.option, dispensary = param.dispensary, isKiosk = param.isKiosk, _param_defaultLimit = param.defaultLimit, defaultLimit = _param_defaultLimit === void 0 ? 10 : _param_defaultLimit;
    var quantityRemaining = getRawQuantityRemaining(product, option, {
        isKiosk: isKiosk,
        defaultLimit: defaultLimit
    });
    var checkoutLimit = getCheckoutLimit(dispensary);
    return _.clamp(quantityRemaining, 0, checkoutLimit);
}
export var getLimitPerCustomer = function(product, option) {
    var defaultLimit = null;
    if (!product || !product.limitsPerCustomer) {
        return defaultLimit;
    }
    var filtered = _.filter(product.limitsPerCustomer, [
        "key",
        option
    ]);
    if (filtered.length > 0) {
        var value = filtered[0].value;
        return value === 'Unlimited' ? defaultLimit : parseInt(value, 10);
    }
    return defaultLimit;
};
export var optionValMap = {
    '0.02g': 0.02,
    '0.05g': 0.05,
    '0.15g': 0.15,
    '.3g': 0.3,
    '0.3g': 0.3,
    '.5g': 0.5,
    '0.5g': 0.5,
    '0.7g': 0.7,
    '.7g': 0.7,
    '1g': 1.0,
    '1.0g': 1.0,
    '1.2g': 1.2,
    '1.25g': 1.25,
    '1.5g': 1.5,
    '1.75g': 1.75,
    '2g': 2.0,
    '2.5g': 2.5,
    '2.6g': 2.6,
    '2.0g': 2.0,
    '1/8oz': 3.5,
    '3g': 3.0,
    '3.0g': 3.0,
    '3.5g': 3.5,
    '3.6g': 3.6,
    '3.7g': 3.7,
    '3.75g': 3.75,
    '4.0g': 4.0,
    '4g': 4.0,
    '5g': 5.0,
    '5.0g': 5.0,
    '7g': 7.0,
    '1/4oz': 7.0,
    '14g': 14.0,
    '1/2oz': 14.0,
    '28g': 28.0,
    '1oz': 28.0,
    '57g': 57.0,
    '2oz': 57.0,
    '85g': 85.0,
    '3oz': 85.0,
    '113g': 113.0,
    '4oz': 113.0,
    '142g': 142.0,
    '5oz': 142.0,
    '170g': 170.0,
    '6oz': 170.0,
    '198g': 198.0,
    '7oz': 198.0,
    '227g': 227.0,
    '8oz': 227.0,
    'Pre-Rolls': 1.0,
    '.25gC': 0.25,
    '.3gC': 0.3,
    '.4gC': 0.4,
    '.5gC': 0.5,
    '.75gC': 0.75,
    '1gC': 1.0,
    '1.25gC': 1.25,
    '1.5gC': 1.5,
    '1.75gC': 1.75,
    '2gC': 2.0,
    '2.5gC': 2.5
};
export var isMg = function(weight) {
    return weight && MG_WEIGHT_REGEX.test(weight);
};
export var isGram = function(weight) {
    return weight && GRAM_WEIGHT_REGEX.test(weight);
};
export var isConcentrate = function(weight) {
    return weight && CONC_WEIGHT_REGEX.test(weight);
};
export var isOz = function(weight) {
    return weight && OZ_WEIGHT_REGEX.test(weight);
};
export var isPartialOz = function(weight) {
    return weight && PARTIAL_OZ_REGEX.test(weight);
};
export var parseMgWeight = function(weight) {
    var weightOnly = parseMgWeightNoConversion(weight);
    return weightOnly / MG_TO_G;
};
export var parseMgWeightNoConversion = function(weight) {
    var isMgWeight = isMg(weight);
    if (!isMgWeight) {
        return false;
    }
    return MG_WEIGHT_REGEX.exec(weight)[0].slice(0, -2);
};
export var parseGramWeight = function(weight) {
    var isGramWeight = isGram(weight);
    var isConcentrateWeight = isConcentrate(weight);
    if (isGramWeight) {
        var weightOnly = GRAM_WEIGHT_REGEX.exec(weight)[0].slice(0, -1);
        return Number(weightOnly);
    }
    if (isConcentrateWeight) {
        var weightOnly1 = GRAM_WEIGHT_REGEX.exec(weight)[0].slice(0, -2);
        return Number(weightOnly1);
    }
    return false;
};
export var parseOzWeightNoConversion = function(weight) {
    var isPartialOzWeight = isPartialOz(weight);
    if (isPartialOzWeight) {
        return PARTIAL_OZ_REGEX.exec(weight)[0].slice(0, -2);
    }
    var isOzWeight = isOz(weight);
    if (isOzWeight) {
        return OZ_WEIGHT_REGEX.exec(weight)[0].slice(0, -2);
    }
    return -1;
};
export var parseOzWeight = function(weight, defaultWeight) {
    var partials = {
        '1/8': 3.5,
        '1/4': 7.0,
        '1/2': 14.0
    };
    var isPartialOzWeight = isPartialOz(weight);
    if (isPartialOzWeight) {
        var weightOnly = PARTIAL_OZ_REGEX.exec(weight)[0].slice(0, -2);
        return partials[weightOnly] || defaultWeight;
    }
    var isOzWeight = isOz(weight);
    if (isOzWeight) {
        var weightOnly1 = OZ_WEIGHT_REGEX.exec(weight)[0].slice(0, -2);
        return weightOnly1 * GRAM_TO_OZ;
    }
    if (!isOzWeight && !isPartialOzWeight) {
        return false;
    }
    return false;
};
/** @param {string | null | undefined} option */ var parseMultiplier = function(option) {
    var optionParsed = option;
    var multiplier = 1;
    var match = String(optionParsed || '').match(MULTIPLIER_REGEX);
    if (match) {
        multiplier = parseInt(match[1], 10);
        if (Number.isNaN(multiplier)) {
            multiplier = 1;
        }
        // eslint-disable-next-line prefer-destructuring
        optionParsed = match[2];
    }
    return {
        multiplier: multiplier,
        optionParsed: optionParsed
    };
};
/**
 * @param {string | string[] | null | undefined} option - weight option string (e.g. "3.5g", "1/8oz") or array
 * @param {number} [defaultWeight=0.0]
 * @param {number} [quantity=1]
 * @param {boolean} [useHighPrecision=false] - keep sub-hundredth-gram precision (e.g. "0.025g")
 *   instead of the default 2-decimal rounding. Only pass true for callers that align this value
 *   against an external, higher-precision weight (e.g. matching a POS-synced weight bucket) --
 *   the default 2-decimal rounding is intentional everywhere else (display, tax, allotment, specials).
 * @returns {number} weight in grams
 */ export var getProductWeight = function() {
    var option = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : '', defaultWeight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0.0, quantity = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, useHighPrecision = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var precision = useHighPrecision ? 6 : 2;
    if (Array.isArray(toJS(option))) {
        // eslint-disable-next-line prefer-destructuring
        option = toJS(option)[0];
    }
    if (typeof option !== 'string') {
        return parseFloat(Big(defaultWeight).times(parseFloat(quantity)).toFixed(precision));
    }
    var _parseMultiplier = parseMultiplier(option), multiplier = _parseMultiplier.multiplier, optionParsed = _parseMultiplier.optionParsed;
    var NO_LETTERS_REGEX = /[a-z]/i;
    var optionValue = defaultWeight;
    // check our option hash first as an optimization then
    // revert to our parsing
    if (optionParsed === 'N/A' || _.isNil(optionParsed)) {
        optionValue = defaultWeight;
    } else if (optionValMap[optionParsed] !== undefined) {
        optionValue = optionValMap[optionParsed];
    } else if (isGram(optionParsed) || isConcentrate(optionParsed)) {
        optionValue = parseGramWeight(optionParsed);
    } else if (isOz(optionParsed) || isPartialOz(optionParsed)) {
        optionValue = parseOzWeight(optionParsed, defaultWeight);
    } else if (isMg(optionParsed)) {
        optionValue = parseMgWeight(optionParsed);
    } else if (/^(?:\d+(?:\.\d+)?|\.\d+)\s*ml$/i.test(optionParsed)) {
        // Volume in ml treated as grams for compliance (1ml ≈ 1g); supports ".5ml" and "1ml"
        optionValue = parseFloat(optionParsed.match(/^(\d+(?:\.\d+)?|\.\d+)\s*ml$/i)[1]);
    } else if (parseFloat(optionParsed) && !NO_LETTERS_REGEX.test(optionParsed)) {
        // if we didn't pass a weight unit, we can still use the weight value
        optionValue = parseFloat(optionParsed);
    } else if (!_.isFinite(optionValue)) {
        optionValue = 0;
    }
    return parseFloat(Big(optionValue).times(multiplier).times(parseFloat(quantity)).toFixed(precision));
};
export var getProductNetWeightInGrams = function(product) {
    var _product_measurements_netWeight_values, _product_measurements_netWeight, _product_measurements, _product_measurements_netWeight1, _product_measurements1;
    var value = (_product_measurements = product.measurements) === null || _product_measurements === void 0 ? void 0 : (_product_measurements_netWeight = _product_measurements.netWeight) === null || _product_measurements_netWeight === void 0 ? void 0 : (_product_measurements_netWeight_values = _product_measurements_netWeight.values) === null || _product_measurements_netWeight_values === void 0 ? void 0 : _product_measurements_netWeight_values[0];
    var unit = (_product_measurements1 = product.measurements) === null || _product_measurements1 === void 0 ? void 0 : (_product_measurements_netWeight1 = _product_measurements1.netWeight) === null || _product_measurements_netWeight1 === void 0 ? void 0 : _product_measurements_netWeight1.unit;
    if (unit !== MILLIGRAMS || !value) {
        return 0;
    }
    return Number(safeToBig(value).div(MG_TO_G));
};
export var getProductVolumeInGrams = function(product) {
    var _product_measurements_volume_values, _product_measurements_volume, _product_measurements, _product_measurements_volume1, _product_measurements1;
    var value = (_product_measurements = product.measurements) === null || _product_measurements === void 0 ? void 0 : (_product_measurements_volume = _product_measurements.volume) === null || _product_measurements_volume === void 0 ? void 0 : (_product_measurements_volume_values = _product_measurements_volume.values) === null || _product_measurements_volume_values === void 0 ? void 0 : _product_measurements_volume_values[0];
    var unit = (_product_measurements1 = product.measurements) === null || _product_measurements1 === void 0 ? void 0 : (_product_measurements_volume1 = _product_measurements1.volume) === null || _product_measurements_volume1 === void 0 ? void 0 : _product_measurements_volume1.unit;
    if (unit !== MILLILITERS || !value) {
        return 0;
    }
    return Number(safeToBig(value)); // 1ml === 1g
};
export var getProductVolumeInFluidOunces = function(product) {
    var _product_measurements, _volume_values, _product_measurements_netWeight_values, _product_measurements_netWeight, _product_measurements1, _product_measurements_netWeight1, _product_measurements2;
    // measurements.volume can be present with a defined `unit` but an empty `values` array
    // (i.e. "no real volume data" per the GraphQL schema's default shape, not `null`). Resolving
    // `value` and `unit` via independent `??` fallbacks lets that empty-but-truthy `volume.unit`
    // survive while `value` silently falls back to `measurements.netWeight`'s value, pairing a
    // milligram-scale weight with a milliliters unit and skipping the mg->g->fl-oz conversion
    // entirely (see ECOMM-10750 follow-up). Resolve them together from the same source instead.
    var volume = (_product_measurements = product.measurements) === null || _product_measurements === void 0 ? void 0 : _product_measurements.volume;
    var hasVolume = !_.isNil(volume === null || volume === void 0 ? void 0 : (_volume_values = volume.values) === null || _volume_values === void 0 ? void 0 : _volume_values[0]) && !!(volume === null || volume === void 0 ? void 0 : volume.unit);
    var value = hasVolume ? volume.values[0] : (_product_measurements1 = product.measurements) === null || _product_measurements1 === void 0 ? void 0 : (_product_measurements_netWeight = _product_measurements1.netWeight) === null || _product_measurements_netWeight === void 0 ? void 0 : (_product_measurements_netWeight_values = _product_measurements_netWeight.values) === null || _product_measurements_netWeight_values === void 0 ? void 0 : _product_measurements_netWeight_values[0];
    var unit = hasVolume ? volume.unit : (_product_measurements2 = product.measurements) === null || _product_measurements2 === void 0 ? void 0 : (_product_measurements_netWeight1 = _product_measurements2.netWeight) === null || _product_measurements_netWeight1 === void 0 ? void 0 : _product_measurements_netWeight1.unit;
    if (!unit || !value) {
        return 0;
    }
    // if we've only been given a weight, we'll need to convert to ml
    if (unit === MILLIGRAMS || unit === GRAMS) {
        // then lets convert to ml!
        // 1ml === 1g approximately based on water density
        // so we're really just converting to grams if need be
        var gramValue = unit === MILLIGRAMS ? Number(safeToBig(value).div(1000).round(5)) : Number(safeToBig(value));
        var flOzValue = Number(safeToBig(gramValue).div(MILLILITERS_PER_OZ).round(5));
        return flOzValue;
    }
    return unit === MILLILITERS ? Number(safeToBig(value).div(MILLILITERS_PER_OZ).round(5)) : 0;
};
export var getEquivalent = function(product, option, quantity) {
    var field = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "standardEquivalent";
    var _product_POSMetaData;
    var childProduct = _.find((_product_POSMetaData = product.POSMetaData) === null || _product_POSMetaData === void 0 ? void 0 : _product_POSMetaData.children, {
        option: option
    });
    var equivalentUnit = _.get(childProduct, "".concat(field, ".unit"));
    var equivalentValue = equivalentUnit === 'g' && _.get(childProduct, "".concat(field, ".value"));
    return equivalentValue ? equivalentValue * quantity : null;
};
export function formatWeightOptions(param) {
    var _param_options = param.options, options = _param_options === void 0 ? [] : _param_options, _param_prices = param.prices, prices = _param_prices === void 0 ? [] : _param_prices, _param_limitsPerCustomer = param.limitsPerCustomer, limitsPerCustomer = _param_limitsPerCustomer === void 0 ? [] : _param_limitsPerCustomer, _param_optionsBelowThreshold = param.optionsBelowThreshold, optionsBelowThreshold = _param_optionsBelowThreshold === void 0 ? [] : _param_optionsBelowThreshold, _param_optionsBelowKioskThreshold = param.optionsBelowKioskThreshold, optionsBelowKioskThreshold = _param_optionsBelowKioskThreshold === void 0 ? [] : _param_optionsBelowKioskThreshold, _param_weightOnlyLabel = param.weightOnlyLabel, weightOnlyLabel = _param_weightOnlyLabel === void 0 ? false : _param_weightOnlyLabel, _param_manualInventory = param.manualInventory, manualInventory = _param_manualInventory === void 0 ? [] : _param_manualInventory, _param_isKiosk = param.isKiosk, isKiosk = _param_isKiosk === void 0 ? false : _param_isKiosk, _param_showQualifyingOptions = param.showQualifyingOptions, showQualifyingOptions = _param_showQualifyingOptions === void 0 ? false : _param_showQualifyingOptions, _param_qualifyingOptions = param.qualifyingOptions, qualifyingOptions = _param_qualifyingOptions === void 0 ? [] : _param_qualifyingOptions;
    var chain = flow(map.convert({
        cap: false
    })(function(opt, i) {
        var price = parseFloat(prices[i]).toFixed(2);
        var label;
        if (weightOnlyLabel) {
            label = opt.weight ? opt.weight.replace("oz", " oz").replace("gC", "g") : opt.replace("oz", " oz").replace("gC", "g");
        } else {
            label = "".concat(opt.weight ? opt.weight.replace("oz", " oz").replace("gC", "g") : opt.replace("oz", " oz").replace("gC", "g"), " - $").concat(price);
        }
        return {
            value: opt,
            price: price,
            label: label
        };
    }), filter(function(param) {
        var value = param.value;
        var limit = getLimitPerCustomer({
            limitsPerCustomer: limitsPerCustomer
        }, value);
        if (limit === 0) {
            return false;
        }
        if (!isKiosk && (optionsBelowThreshold === null || optionsBelowThreshold === void 0 ? void 0 : optionsBelowThreshold.length) && _.includes(optionsBelowThreshold, value)) {
            return false;
        }
        if (isKiosk && (optionsBelowKioskThreshold === null || optionsBelowKioskThreshold === void 0 ? void 0 : optionsBelowKioskThreshold.length) && _.includes(optionsBelowKioskThreshold, value)) {
            return false;
        }
        if (manualInventory === null || manualInventory === void 0 ? void 0 : manualInventory.length) {
            var inventoryOption = _.find(manualInventory, [
                "option",
                value
            ]);
            if (inventoryOption) {
                return inventoryOption.inventory > 0;
            }
            return true;
        }
        if (showQualifyingOptions && !_.includes(qualifyingOptions, value)) {
            return false;
        }
        return true;
    }), uniqBy(function(param) {
        var value = param.value;
        return _.replace(value, 'C', '');
    }));
    return chain(options);
}
export var getThreshold = function(product, integration) {
    return ((integration === null || integration === void 0 ? void 0 : integration.thresholds) || {})[product.type] || 5;
};
export var imgixProductImageURL = function(imagePath) {
    return replaceAWSSourceWithImgix(imagePath);
};
export var imageToUse = function() {
    var product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var __head, __head1, _product_brand, _product_brand1;
    var _product_images;
    var activeImages = _.filter((_product_images = product.images) !== null && _product_images !== void 0 ? _product_images : [], [
        "active",
        true
    ]);
    var productImage = _.isEmpty((__head = _.head(activeImages)) === null || __head === void 0 ? void 0 : __head.url) ? null : (__head1 = _.head(activeImages)) === null || __head1 === void 0 ? void 0 : __head1.url;
    var brandImage = _.isEmpty((_product_brand = product.brand) === null || _product_brand === void 0 ? void 0 : _product_brand.imageUrl) ? null : (_product_brand1 = product.brand) === null || _product_brand1 === void 0 ? void 0 : _product_brand1.imageUrl;
    var productStockImage = _.isEmpty(product.stockImage) ? null : product.stockImage;
    var legacyBrandImage = _.isEmpty(product.brandLogo) ? null : product.brandLogo;
    var legacyProductImage = _.isEmpty(product.Image) ? null : product.Image;
    var legacyDefaultImageLookupType = product.type === 'Flower' && product.strainType ? product.strainType : product.type;
    var legacyDefaultImage = legacyDefaultImageLookupType ? DefaultImages[legacyDefaultImageLookupType] : DefaultImages.Flower;
    var _ref, _ref1, _ref2, _ref3;
    return (_ref3 = (_ref2 = (_ref1 = (_ref = productImage !== null && productImage !== void 0 ? productImage : brandImage) !== null && _ref !== void 0 ? _ref : legacyBrandImage) !== null && _ref1 !== void 0 ? _ref1 : productStockImage) !== null && _ref2 !== void 0 ? _ref2 : legacyProductImage) !== null && _ref3 !== void 0 ? _ref3 : legacyDefaultImage;
};
export var getCanonicalIDForOption = function(product, option) {
    if (product.POSMetaData.children.length) {
        var __find;
        return (__find = _.find(product.POSMetaData.children, {
            option: option
        })) === null || __find === void 0 ? void 0 : __find.canonicalID;
    }
    return product.POSMetaData.canonicalID;
};
export var formatWeight = function(valProp) {
    /*
   * format a weight for comparison
   * acceptable units of mass from js-quantities
   * ["AMU", "carat", "dalton", "dram", "grain", "gram", "kilogram",
   * "metric-ton", "ounce", "pound", "short-ton", "slug", "stone"]
   */ var possibleWeights = [
        {
            str: " oz",
            repl: " ounce"
        },
        {
            str: "oz",
            repl: " ounce"
        },
        {
            str: " g",
            repl: " gram"
        },
        {
            str: "g",
            repl: " gram"
        },
        {
            str: " gC",
            repl: " gram"
        },
        {
            str: "gC",
            repl: " gram"
        }
    ];
    var val = valProp.replace("[dot]", ".");
    var matchedStringIndex = "";
    _.forEach(possibleWeights, function(w, i) {
        return _.includes(val, w.str) ? matchedStringIndex = i : null;
    });
    if (_.isString(matchedStringIndex)) {
        console.error("Unable to parse ", val);
        return new Error();
    }
    var unitTypedVal = val.replace(possibleWeights[matchedStringIndex].str, possibleWeights[matchedStringIndex].repl).replace('  ', ' ');
    // convert to decimal if needed
    var decimalVal = unitTypedVal;
    if (_.includes(unitTypedVal, '/')) {
        var valUnitSplit = _.split(unitTypedVal, ' ');
        var fractionSplit = _.split(valUnitSplit[0], '/');
        var decimal = parseInt(fractionSplit[0], 10) / parseInt(fractionSplit[1], 10);
        decimalVal = "".concat(decimal, " ").concat(valUnitSplit[1]);
    }
    return decimalVal;
};
// Temporarily check the Title Cased effects and camelCased effects
export var filterLegacyEffects = function(effects) {
    return _.filter(effects, function(effect) {
        return _.includes(productEffects, effect) || _.includes(normalizeProductEffects(productEffects), effect);
    });
};
export var normalizeProductEffects = function(effects) {
    return _.map(effects, function(effect) {
        return _.camelCase(effect);
    });
};
// Returns normalized (camel case) effect keys where the effect value is greater than 0
export var parseEffects = function(effects) {
    var appliedEffectKeys = _.keys(_.pickBy(effects, function(value, _key) {
        return _.toNumber(value) > 0;
    }));
    var normalizedEffectKeys = normalizeProductEffects(appliedEffectKeys);
    return filterLegacyEffects(normalizedEffectKeys);
};
export var applicableEffectsList = function(param) {
    var state = param.state;
    var effectList = productEffects;
    if (state && state.length) {
        var restrictedEffects = getComplianceConfig(state, "restrictions.effects");
        if (restrictedEffects === null || restrictedEffects === void 0 ? void 0 : restrictedEffects.length) {
            var _$_;
            effectList = (_$_ = _).without.apply(_$_, [
                effectList
            ].concat(_to_consumable_array(restrictedEffects)));
        }
    }
    return effectList;
};
export var applicableEffects = function(param) {
    var effects = param.effects, state = param.state;
    var effectList = applicableEffectsList({
        state: state
    });
    return _.pickBy(effects, function(value, key) {
        return _.isFinite(parseInt(value, 10)) && parseInt(value, 10) > 0 && _.includes(effectList, key);
    });
};
export function highestMatchingPrices(menuType, p1, p2) {
    var p1Price = p1["".concat(menuType, "Prices")];
    var p2Price = p2["".concat(menuType, "Prices")];
    if (p1Price.length === 1 && p2Price.length === 1) {
        return [
            p1Price[0],
            p2Price[0]
        ];
    }
    for(var p1Index = p1Price.length - 1; p1Index >= 0; --p1Index){
        for(var p2Index = p2Price.length - 1; p2Index >= 0; --p2Index){
            if (p1.Options[p1Index] === p2.Options[p2Index]) {
                return [
                    p1Price[p1Index],
                    p2Price[p2Index]
                ];
            }
        }
    }
    // worst comes to worst just return the cheapest prices...
    // (previous behavior)
    return [
        p1Price[0],
        p2Price[0]
    ];
}
export function getSortingFunctions(menuType) {
    return {
        custom: function(p1, p2) {
            return p1.weight - p2.weight;
        },
        brand: function(p1, p2) {
            if (p1.brandName === null) {
                return 1;
            }
            if (p2.brandName === null) {
                return -1;
            }
            if (p1.brandName > p2.brandName) {
                return 1;
            }
            if (p1.brandName < p2.brandName) {
                return -1;
            }
            if (p1.Name > p2.Name) {
                return 1;
            }
            if (p1.Name < p2.Name) {
                return -1;
            }
            return 0;
        },
        alpha: function(p1, p2) {
            if (p1.Name > p2.Name) {
                return 1;
            }
            if (p1.Name < p2.Name) {
                return -1;
            }
            return 0;
        },
        priceLowToHigh: function(p1, p2) {
            var _highestMatchingPrices = _sliced_to_array(highestMatchingPrices(menuType, p1, p2), 2), p1Price = _highestMatchingPrices[0], p2Price = _highestMatchingPrices[1];
            return p1Price - p2Price;
        },
        priceHighToLow: function(p1, p2) {
            var _highestMatchingPrices = _sliced_to_array(highestMatchingPrices(menuType, p1, p2), 2), p1Price = _highestMatchingPrices[0], p2Price = _highestMatchingPrices[1];
            return p2Price - p1Price;
        },
        potency: function(p1, p2) {
            var p1Potency = getPotencyValues(p1);
            var p2Potency = getPotencyValues(p2);
            if (!p2Potency.THC && !p1Potency.THC) {
                return Number(p2Potency.CBD || 0) - Number(p1Potency.CBD || 0);
            }
            return Number(p2Potency.THC || 0) - Number(p1Potency.THC || 0);
        },
        strain: function(p1, p2) {
            return StrainTypeOrder[p1.strainType] - StrainTypeOrder[p2.strainType];
        }
    };
}
export var getProductBasePrice = function(medicalOrder, item) {
    var _item_product_preTaxRecPrices;
    var priceIndex = _.indexOf(item.product.Options, item.option);
    if (medicalOrder) {
        var _item_product_preTaxMedPrices;
        return ((_item_product_preTaxMedPrices = item.product.preTaxMedPrices) === null || _item_product_preTaxMedPrices === void 0 ? void 0 : _item_product_preTaxMedPrices[priceIndex]) || item.price;
    }
    return ((_item_product_preTaxRecPrices = item.product.preTaxRecPrices) === null || _item_product_preTaxRecPrices === void 0 ? void 0 : _item_product_preTaxRecPrices[priceIndex]) || item.price;
};
export var validateNumber = function(value) {
    if (value === '' || _.isFinite(value)) {
        return value;
    }
    return null;
};
// TODO should we also be considering units here?
export var saleSatisfiesWeightCondition = function(inputWeight, operator, operatorWeights) {
    var appliesToAnyWeight = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (appliesToAnyWeight) {
        return true;
    }
    if (!operatorWeights || operatorWeights.length < 1) {
        return false;
    }
    /*
     here if operator weights exists we know there is some restriction
     and if that restriction doesn't include n/a we can return false
     this will prevent n/a from getting accepted as part of a weighted sale
     and will also allow us in the future to potentially include n/a as an option
     for a weighted sale (not that we would?)
  */ if (_.toLower(inputWeight) === 'n/a') {
        return _.some(operatorWeights, function(opWeight) {
            return _.toLower(opWeight) === _.toLower(inputWeight);
        });
    }
    // If equalTo or an array of weights (v1 discount sync only)
    if (operator === 'equalTo' || operatorWeights.length > 1) {
        return _.some(operatorWeights, function(opWeight) {
            return parseFloat(inputWeight) === parseFloat(opWeight.toString());
        });
    }
    if (operator === 'greaterThan') {
        return parseFloat(inputWeight) > parseFloat(operatorWeights === null || operatorWeights === void 0 ? void 0 : operatorWeights[0]);
    }
    if (operator === 'greaterThanEqualTo') {
        return parseFloat(inputWeight) >= parseFloat(operatorWeights === null || operatorWeights === void 0 ? void 0 : operatorWeights[0]);
    }
    return true;
};
/** @return {CategoriesForMenu} */ export var getCategoriesForMenuForState = function(state) {
    var categories = _.map(CategoriesForMenu, function(category) {
        if (category.key === 'edibles' && state === 'PA') {
            return {
                key: 'ingestibles',
                label: 'Ingestibles',
                value: 'Edible'
            };
        }
        return category;
    });
    return categories;
};
export var getSubcategoryOptionsForState = function(state) {
    var options = _.clone(SubcategoryOptions);
    if (state === 'FL') {
        _.set(options, 'Edible', _.filter(options.Edible, function(param) {
            var key = param.key;
            return key !== 'drinks';
        }));
    }
    return options;
};
// eslint-disable-next-line lodash/prefer-lodash-method
export var getCategoryForProduct = function(product) {
    return CategoryOptions.find(function(param) {
        var value = param.value;
        return value === (product === null || product === void 0 ? void 0 : product.type);
    });
};
export var getCategoryOptionsForRetailer = function(dispensary) {
    var _dispensary_location;
    var state = ((_dispensary_location = dispensary === null || dispensary === void 0 ? void 0 : dispensary.location) !== null && _dispensary_location !== void 0 ? _dispensary_location : {}).state;
    var options = _.map(CategoryOptions, function(category) {
        if (category.key === 'edibles') {
            if (state === 'FL') {
                return {
                    key: 'edibles',
                    label: 'Edibles',
                    value: 'Edible',
                    subcategories: _.filter(SubcategoryOptions.Edible, function(param) {
                        var key = param.key;
                        return key !== 'drinks';
                    })
                };
            }
            if (state === 'PA') {
                return {
                    key: 'ingestibles',
                    label: 'Ingestibles',
                    value: 'Edible',
                    subcategories: SubcategoryOptions.Edible
                };
            }
        }
        return category;
    });
    return options;
};
export var getSubcategoryOptionsForRetailer = function(dispensary) {
    var _dispensary_location;
    var state = ((_dispensary_location = dispensary === null || dispensary === void 0 ? void 0 : dispensary.location) !== null && _dispensary_location !== void 0 ? _dispensary_location : {}).state;
    var options = _.clone(SubcategoryOptions);
    if (state === 'FL') {
        _.set(options, 'Edible', _.filter(options.Edible, function(param) {
            var key = param.key;
            return key !== 'drinks';
        }));
    }
    return options;
};
export var getProductImage = function() {
    var product = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _product_active, _product_origin;
    var productImage = {
        _id: product._id,
        url: product.url,
        userId: product.userId,
        active: (_product_active = product.active) !== null && _product_active !== void 0 ? _product_active : true,
        origin: (_product_origin = product.origin) !== null && _product_origin !== void 0 ? _product_origin : 'admin',
        description: '',
        label: ''
    };
    return productImage;
};
export var getFirstActiveImage = function(images) {
    // eslint-disable-next-line lodash/prefer-lodash-method
    var firstActiveImage = images.find(function(img) {
        return img.active === true;
    });
    return firstActiveImage;
};
export var strainEffects = {
    Indica: {
        Relaxed: 9,
        Sleepy: 8,
        Happy: 8
    },
    Sativa: {
        Energetic: 9,
        Happy: 9,
        Creative: 8,
        Focused: 8,
        Inspired: 8
    },
    Hybrid: {
        Calm: 9,
        Happy: 8,
        Relaxed: 6,
        Energetic: 5
    },
    'High CBD': {
        'Clear Mind': 9,
        Calm: 8,
        Relaxed: 5,
        Happy: 5
    }
};
export var getFilteredProduct = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(productId, apolloClient) {
        var variables, response;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    variables = {
                        perPage: 1,
                        productsFilter: {
                            productId: productId,
                            limit: 1
                        }
                    };
                    return [
                        4,
                        apolloClient.query({
                            fetchPolicy: 'network-only',
                            query: adminFilteredProducts,
                            variables: variables
                        })
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        _.get(response, 'data.filteredProducts.products[0]', null)
                    ];
            }
        });
    });
    return function getFilteredProduct(productId, apolloClient) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * @param {Object} product
 * @param {Object[]} parsedOptions
 * @returns {boolean}
 */ export function isOutOfStock(product, parsedOptions) {
    var _product_POSMetaData_children_, _product_POSMetaData_children, _product_POSMetaData;
    return ((_product_POSMetaData = product.POSMetaData) === null || _product_POSMetaData === void 0 ? void 0 : (_product_POSMetaData_children = _product_POSMetaData.children) === null || _product_POSMetaData_children === void 0 ? void 0 : (_product_POSMetaData_children_ = _product_POSMetaData_children[0]) === null || _product_POSMetaData_children_ === void 0 ? void 0 : _product_POSMetaData_children_.quantity) === 0 || (parsedOptions === null || parsedOptions === void 0 ? void 0 : parsedOptions.length) === 0;
}
export var getSpecialsPerQualifyingWeight = function(param) {
    var option = param.option, _param_bogoSpecials = param.bogoSpecials, bogoSpecials = _param_bogoSpecials === void 0 ? [] : _param_bogoSpecials;
    var conditionIds = [];
    var rewardIds = [];
    _.forEach(bogoSpecials, function(special) {
        if (_.includes(special === null || special === void 0 ? void 0 : special.qualifyingConditionOptions, option)) {
            conditionIds.push(special.specialId);
        }
        if (_.includes(special === null || special === void 0 ? void 0 : special.qualifyingRewardOptions, option)) {
            rewardIds.push(special.specialId);
        }
    });
    return {
        conditionIds: conditionIds,
        rewardIds: rewardIds
    };
};
